import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "personal-information-wrapper box" }
const _hoisted_2 = {
  key: 0,
  "data-test-id": "personal-info-form"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "font-bold text-lg" }, "Edit Profile", -1)
const _hoisted_4 = {
  key: 1,
  class: "personal-information mb-12",
  "data-test-id": "personal-info"
}
const _hoisted_5 = { class: "py-2" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "text-sm text-blue-50 whitespace-pre pl-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_personal_info_form = _resolveComponent("personal-info-form")!
  const _component_personal_info_description = _resolveComponent("personal-info-description")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_ctx.showForm && _ctx.edit)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_personal_info_form, {
            input: _ctx.grokUser,
            onClosePersonalInfoForm: _ctx.closePersonalInfoForm
          }, null, 8, ["input", "onClosePersonalInfoForm"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_personal_info_description, {
              user: _ctx.grokUser,
              onCloseSidebar: _ctx.closeSidebar
            }, null, 8, ["user", "onCloseSidebar"]),
            (_ctx.edit)
              ? (_openBlock(), _createElementBlock("section", _hoisted_6, [
                  _createElementVNode("span", _hoisted_7, [
                    _createElementVNode("button", {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showForm = !_ctx.showForm)),
                      class: "btn btn-small btn-secondary"
                    }, " Edit Profile ")
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
  ]))
}